export default {
  AddonAdda: 'एक जोडा जोडा',
  notFindAdda: 'आपला अडा शोधू शकलो नाही? कृपया तुमचा अड्डा जोडा',
  AddPhoto: 'फोटो जोडा',
  earnMpoints: 'एमपी पॉइंट्स मिळविण्यासाठी अ‍ॅडमध्ये एक अ‍ॅड किंवा चेकइन जोडा',
  postOffice: 'पोस्ट ऑफिस',
  meter: 'मीटर',
  VerifiedbyMall91: 'मॉल 91 द्वारे सत्यापित',
  Suggestandedit: 'संपादन सुचवा',
  GiveRating: 'रेटिंग द्या',
  Details: 'तपशील',
  MondaytoSaturday: 'सोमवार ते शनिवार',
  checkIn: 'चेकइन',
  CheckInAtAdda: 'अडावर चेक इन करा',
  ShareExperience: 'आपला अनुभव अडाबरोबर सामायिक करा आणि एमपीइंट्स मिळवा',
  AddaName: 'अडाचे नाव',
  AddAddanotfound: 'अड्डा सापडला नाही',
  Iamhere: 'मी येथे आहे',
  Writesomethinghere: 'कृपया काही शब्द लिहा ..',
  plzCheckin: 'चेकइन',
  PickyourCurrentLocation: 'आपले वर्तमान स्थान निवडा',
  TurnonLocation: 'स्थान सेवा चालू करा',
  NoRecordsavailable: 'रेकॉर्ड उपलब्ध नाहीत',
  YoursPosts: 'आपले पोस्ट्स',
  Makeasuggestion: 'एक सल्ला द्या',
  Helpwithyoursuggestion: 'आपल्या मौल्यवान सूचनांसह आम्हाला मदत करा',
  Addnewphoto: 'नवीन फोटो जोडा',
  warning: 'संबंधित चित्रे आणि अचूक माहितीसह आपल्या सूचनांचे समर्थन करा.',
  submit: 'प्रस्तुत करणे',
  AllcheckIns: 'सर्व चेकइन',
  Nearbycheckins: 'जवळील चेकिन',
  Home: 'मुख्यपृष्ठ',
  AllAddas: 'सर्व अडास',
  Notification: 'सूचना',
  Profile: 'प्रोफाइल',
  TotalPost: 'एकूण पोस्ट',
  TotalLikes: 'एकूण आवडी',
  TotalComments: 'एकूण टिप्पण्या',
  Peoplehavecommented: 'लोकांनी प्रतिक्रिया दिल्या आहेत',
  TypeAcomment: 'आपली सामग्री येथे टाइप करा ..',
  GototheAdda: 'अडावर जा',
  intro: 'एका अडावर एक नवीन अ‍ॅडा किंवा चेकइन जोडा आणि एमपी पॉईंट मिळवा',
  Peoplehaveliked: 'लोकांना आवडले आहे',
  whichplaceyoustand: 'आपण आता कोणत्या अडावर आहात? चेकइन!',
  Atwhichplace: 'आपण आता कोणत्या अडावर आहात? चेकइन!',
  likes: 'आवडी',
  share: 'सामायिक करा',
  like: 'आवडले',
  comments: 'टिप्पण्या',
  isAt: 'येथे आहे',
  FullAddress: 'संपूर्ण पत्ता',
  housenumber: 'घर क्रमांक, रस्ता किंवा गाव',
  BusinessName: 'व्यवसायाचे नाव',
  Suchas: 'अग्रवाल मिठाई',
  AddNewCategory: 'नवीन श्रेणी जोडा',
  CREATE: 'तयार करा',
  CANCEL: 'रद्द करा',
  city: 'शहर',
  addCity: 'शहर जोडा',
  Mobile: 'संपर्क क्रमांक',
  enterMobileNumber: 'मोबाइल नंबर प्रविष्ट करा',
  pincode: 'पिन',
  enterpincode: 'पिन',
  state: 'राज्य',
  AddState: 'राज्य जोडा',
  wentWrong: 'काहीतरी चूक झाली!! कृपया पुन्हा प्रयत्न करा',
  category: 'वर्ग',
  Createcategory: 'श्रेणी तयार करा',
  UploadingImage: 'फोटो अपलोड करत आहे',
  AddAdda: 'जोडा जोडा',
  nofeed: 'काहीच बातमी नाही',
  PleaseEnterdetails: 'कृपया तपशील प्रविष्ट करा',
  Pleaseentercomment: 'कृपया टिप्पणी प्रविष्ट करा',
  NoRecordsfound: 'रेकॉर्ड आढळले नाहीत',
  Citymustbevalid: 'शहर वैध असणे आवश्यक आहे',
  Pinmustbevalid: 'पिन वैध असणे आवश्यक आहे',
  Mobilenomustbevalid: 'मोबाईल क्र. वैध असणे आवश्यक आहे',
  Businessnamemustbevalid: 'व्यवसायाचे नाव वैध असणे आवश्यक आहे',
  Photo: 'छायाचित्र',
  Pleaseselectshopname: 'कृपया दुकानाचे नाव निवडा',
  Pleaseuploadphoto: 'कृपया फोटो अपलोड करा',
  isnecessary: 'आवश्यक आहे!',
  Categorycreated: 'श्रेणी यशस्वीरित्या तयार केली',
  ThisCategoryAlreadyExists: 'हा वर्ग आधीच अस्तित्त्वात आहे',
  Pleasecreatecategory: 'कृपया श्रेणी तयार करा'
}
